var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloningDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0918,
    cy: 7.93173,
    r: 6.67136,
    stroke: "#BBBBBB",
    strokeWidth: 2.46972
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.97458,
    cy: 8.11899,
    r: 7.28879,
    fill: "#BBBBBB",
    stroke: "#BBBBBB",
    strokeWidth: 1.23486
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2151_21288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89429 9.42018L6.08906 11.2254C5.80253 11.5119 5.33793 11.5121 5.05148 11.2257L4.70561 10.8798C4.41916 10.5934 4.41934 10.1288 4.70588 9.84222L6.51111 8.03699L4.70707 6.23295C4.42062 5.94651 4.4208 5.48191 4.70734 5.19537L5.05345 4.84926C5.33998 4.56273 5.80458 4.56255 6.09103 4.84899L7.89507 6.65303L9.7003 4.8478C9.98684 4.56127 10.4514 4.56109 10.7379 4.84753L11.0838 5.1934C11.3702 5.47985 11.37 5.94445 11.0835 6.23099L9.27826 8.03622L11.0823 9.84026C11.3687 10.1267 11.3686 10.5913 11.082 10.8778L10.7359 11.224C10.4494 11.5105 9.98478 11.5107 9.69833 11.2242L7.89429 9.42018Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2151_21288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.8251,
    height: 7.8251,
    fill: "white",
    transform: "translate(3.98047 4.1261)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloningDisabled);
export default __webpack_public_path__ + "static/media/CloningDisabled.d8959de5c99d8174d089a792dae7bd29.svg";
export { ForwardRef as ReactComponent };